// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progressbar-wrapper[data-v-9b3c5752]{margin-top:35px;display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
